// Actions
export const FETCH = 'WAYBILLS/FETCH';
export const FETCH_STARTED = 'WAYBILLS/FETCH_STARTED';
export const RECEIVED = 'WAYBILLS/RECEIVED';
export const ERRORED = 'WAYBILLS/ERRORED';

// Initial state for reducer
export const initialState = {
    loading: false,
    response: null,
    error: null,
};

// Reducer(s)
export default function waybillsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_STARTED:
            return {
                ...state,
                loading: true,
            };
        case RECEIVED:
            return {
                ...state,
                loading: false,
                response: action.response,
                error: null,
            };
        case ERRORED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
}

// Action creators
export const fetchWaybills = query => ({
    type: FETCH,
    query,
});
